import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { BehaviorSubject, fromEvent } from 'rxjs';
import { ZalamoObject } from 'ZalamoLibrary/src/lib/zalamo/pipes/names/graphql';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { filter, map, tap } from 'rxjs/operators';
import { ZalamoDialogService } from 'ZalamoLibrary/src/lib/ui/zalamo-dialog/zalamo-dialog.service';
import { GetImageUrlService } from 'ZalamoLibrary/src/lib/core/image/image-loader/get-image-url.service';
import { Store } from '@ngrx/store';
import { ShoppingCartService } from '../../../../../../../public-session/src/app/shopping-cart.service';
import { AliveState } from 'ZalamoLibrary/src/lib/core/ActiveState';
import { Required } from 'ZalamoLibrary/src/lib/core/decorators/Required';

@Component({
    selector: 'lib-fullscreen-image-viewer',
    templateUrl: './fullscreen-image-viewer.component.html',
    styleUrls: ['./fullscreen-image-viewer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FullscreenImageViewerComponent
  extends AliveState
  implements OnInit
{
  @Input() photo;
  @Output() closed = new EventEmitter();
  @Input() allPhotos: Array<{ photoId: string; photoGroupId: string }> = [];
  @Input() currentIndex = 0;
  @Output() indexChanged = new EventEmitter<{ prev: number; next: number }>();
  loaded$ = new BehaviorSubject(true);
  @Output() beforeClose = new EventEmitter();
  currentPhoto$ = new BehaviorSubject<{
    photoId: string;
    photoGroupId: string;
  }>(null);
  urlLoaded = new EventEmitter<{ index: number; url: string }>();
  @Required context: ZalamoObject;
  @Required contextId: any;
  hideNavigation$ = new BehaviorSubject(false);
  @HostBinding('class.loaded') loaded2 = false;
  imageVisible = true;
  @ViewChild('fullscreen', { static: false }) fullscreen: ElementRef;
  isMobile$ = this.intersection
    .observe(Breakpoints.Handset)
    .pipe(map((res) => res.matches));

  constructor(
    public elementRef: ElementRef,
    private cd: ChangeDetectorRef,
    private dialog: ZalamoDialogService,
    private imageLoader: GetImageUrlService,
    private store: Store,
    private shoppingCartService: ShoppingCartService,
    private intersection: BreakpointObserver
  ) {
    super();
  }

  playMenu() {
    this.loaded2 = true;
    this.cd.detectChanges();
  }

  ngOnInit(): void {
    this.currentPhoto$.next(this.allPhotos[this.currentIndex]);
    this.subscribeWhileAlive(
      fromEvent<{
        target: HTMLElement;
        key: 'Escape' | 'ArrowRight' | 'ArrowLeft';
      }>(document.body, 'keydown').pipe(
        filter(
          ({ target, key }) =>
            this.loaded2 &&
            (target === this.elementRef.nativeElement ||
              target.contains(this.elementRef.nativeElement) ||
              this.elementRef.nativeElement.contains(target))
        ),
        tap((x) => {
          switch (x.key) {
            case 'Escape':
              this.close();
              break;
            case 'ArrowRight':
              this.next();
              break;
            case 'ArrowLeft':
              this.prev();
              break;
          }
        })
      )
    );
  }

  close() {
    this.beforeClose.emit();
    this.loaded2 = false;
    this.imageVisible = false;
    // setTimeout(() => {
    this.loaded$.next(false);
    // }, 250);
    this.closed.emit();
  }

  animationEnd(ev: any) {
    if (ev.toState === 'void') {
      this.closed.emit(true);
    }
  }

  next() {
    if (this.currentIndex === this.allPhotos.length - 1) {
      this.currentIndex = 0;
      this.indexChanged.emit({
        prev: this.allPhotos.length - 1,
        next: 0,
      });
    } else {
      this.indexChanged.emit({
        prev: this.currentIndex++,
        next: this.currentIndex,
      });
    }

    this.currentPhoto$.next(this.allPhotos[this.currentIndex]);
    if (!this.allPhotos[this.currentIndex].photoId) {
      this.next();
    }
  }

  prev() {
    if (this.currentIndex === 0) {
      this.currentIndex = this.allPhotos.length - 1;
      this.indexChanged.emit({
        prev: 0,
        next: this.allPhotos.length - 1,
      });
    } else {
      this.indexChanged.emit({
        prev: this.currentIndex--,
        next: this.currentIndex,
      });
    }

    this.currentPhoto$.next(this.allPhotos[this.currentIndex]);
    if (!this.allPhotos[this.currentIndex].photoId) {
      this.prev();
    }
  }
}
